export const NURSES_ACTIONS = {
    SUGGESTION: 'SUGGESTION_NURSES',
    SUGGESTION_CLEAN: 'SUGGESTION_CLEAN_NURSES',
    FIND: 'FIND_NURSES',
    GET: 'GET_NURSES',
    CHANGE_STATUS: 'CHANGE_STATUS_NURSES',
    SUCCESS: 'SUCCESS_NURSES',
    ERROR: 'ERROR_NURSES',
    CLEAN: 'CLEAN_NURSES',
}